import { useRef } from 'react';

type Predicate<P extends unknown[]> = (...args: P) => boolean;
export const not =
  <P extends unknown[]>(fn: Predicate<P>) =>
  (...args: Parameters<typeof fn>): boolean =>
    !fn(...args);

const sum = (numbers: (number | undefined)[]) =>
  numbers.reduce<number>((acc, num) => acc + (num ?? 0), 0);

export const sumBy =
  <T>(fn: (item: T) => number | undefined) =>
  (items: T[]) =>
    sum(items.map(fn));

export const computeCost = ({
  unitPrice,
  quantity,
}: {
  unitPrice: number;
  quantity: number;
}) => unitPrice * quantity;

export const identity = <T>(value: T): T => value;

export const capitalize = ([first = '', ...rest]: string) =>
  [first.toUpperCase(), ...rest].join('');

function* idMaker() {
  let id = 0;

  while (true) {
    yield `luid-${id}`;
    id += 1;
  }
}
const localId = idMaker();

export const uniqueId = () => {
  const id = localId.next().value;

  if (!id) {
    throw new Error('Ran out of unique IDs');
  }

  return id;
};

export const useUniqueId = (id?: string) => {
  const uniqueIdRef = useRef(id ?? uniqueId());
  return uniqueIdRef.current;
};
